import React, { useState, useEffect, Fragment } from 'react'
import './App.scss'
import QPI from './components/QPI'
import Controls from './components/controls/Controls'
import GradeList from './components/grades_list/GradeList'
import Form from './components/form/Form'
import MinimumQPI from './components/computer/MinimumQPI'
// import Hero from "./components/home/Hero"

function App () {
  const disregardedSubjects = [
    'INTACT',
    'PHYED',
    'NSTP',
    'ENGLISH 8',
    'ENGLISH 9',
    'ENGLISH 10',
    'FILIPINO 8',
    'FILIPINO 9',
    'FILIPINO 10',
    'MATH 1',
    'MATH 1.1',
    'MATH 1.2'
  ]
  const [qpi, setQPI] = useState('-')
  const [grades, setGrades] = useState([])
  const [courseNodeList, setCourseNodeList] = useState([])
  const [gradesNodeList, setGradesNodeList] = useState([])
  const [unitsNodeList, setUnitsNodeList] = useState([])
  const [deleteNodeList, setDeleteNodeList] = useState([])
  const [gradesAndUnits, setGradesAndUnits] = useState([])

  const [courseList, setCourseList] = useState([])
  const [letterList, setLetterList] = useState([])
  const [unitList, setUnitList] = useState([])
  const [closeList, setCloseList] = useState([])

  useEffect(() => {
    addTemplates()
  }, [grades])

  useEffect(() => {
    setCourseNodeList(document.querySelectorAll('.subject'))
    setUnitsNodeList(document.querySelectorAll('.unit'))
    setDeleteNodeList(document.querySelectorAll('.close'))
    setGradesNodeList(document.querySelectorAll('.grades'))
  }, [letterList])

  useEffect(() => {
    displayGrades(grades, gradesNodeList, unitsNodeList)
    computeGrades()
  }, [gradesNodeList])
  const removeSubjects = gradeSet => {
    let subject = gradeSet[0].split(' ')[0]
    if (
      disregardedSubjects.includes(subject) ||
      disregardedSubjects.includes(gradeSet[3])
    ) {
      return false
    } else {
      return true
    }
  }
  const displayGrades = (qpiGrades, gradesNode, units) => {
    for (let i = 0; i < qpiGrades.length; i++) {
      switch (qpiGrades[i][3]) {
        case 'A':
          gradesNode[i].value = '4.00'
          break
        case 'B+':
          gradesNode[i].value = '3.50'
          break
        case 'B':
          gradesNode[i].value = '3.00'
          break
        case 'C+':
          gradesNode[i].value = '2.50'
          break
        case 'C':
          gradesNode[i].value = '2.00'
          break
        case 'D':
          gradesNode[i].value = '1.00'
          break
        case 'F':
          gradesNode[i].value = '0.00'
          break
        case 'W':
          gradesNode[i].value = '0.00'
          break
        default:
          gradesNode[i].value = '-'
          break
      }
      units[i].value = qpiGrades[i][2]
    }
  }

  const splitGrades = pastedGrades => {
    let splitted = pastedGrades.split(/\t|\n/)
    if (splitted[0] == 'School Year') {
      splitted.splice(0, 7)
    }
    let splittedLength = splitted.length / 7
    let groupedGrades = []
    for (let i = 0; i < splittedLength; i++) {
      let toPush = splitted.slice(0, 7)
      toPush.splice(0, 3)

      groupedGrades.push(toPush)
      splitted.splice(0, 7)
    }
    let qpiGrades = groupedGrades.filter(removeSubjects)
    setGrades(qpiGrades)
  }

  const computeGrades = () => {
    let totalUnits = 0
    let totalGrades = 0
    for (let i = 0; i < gradesNodeList.length; i++) {
      if ((gradesNodeList[i].value != '-') | (gradesNodeList[i].value != '-')) {
        totalGrades +=
          parseFloat(gradesNodeList[i].value) * parseInt(unitsNodeList[i].value)

        totalUnits += parseInt(unitsNodeList[i].value)
      }
    }
    setGradesAndUnits([totalGrades, totalUnits])
    totalGrades = (totalGrades / totalUnits).toFixed(2)
    if (totalGrades == 'NaN') {
      setQPI('-')
    } else {
      setQPI(totalGrades)
    }
  }

  const changeNames = () => {
    let newGrades = [...grades]
    for (let i = 0; i < newGrades.length; i++) {
      newGrades[i][0] = courseNodeList[i].value
      newGrades[i][2] = unitsNodeList[i].value
      newGrades[i][3] =
        gradesNodeList[i].options[gradesNodeList[i].selectedIndex].text
    }

    setGrades(newGrades)
  }
  const resetGrades = () => {
    setGrades([])
  }
  const addGrades = () => {
    let newGrades = [...grades]
    for (let i = 0; i < newGrades.length; i++) {
      newGrades[i][0] = courseNodeList[i].value
      newGrades[i][2] = unitsNodeList[i].value
      newGrades[i][3] =
        gradesNodeList[i].options[gradesNodeList[i].selectedIndex].text
    }
    newGrades.unshift(['-', '', '3', 'A'])
    setGrades(newGrades)
  }

  const removeGrade = grade => {
    let newGrades = [...grades]
    const index = [...grade.parentElement.children].indexOf(grade) - 1
    newGrades.splice(index, 1)
    setGrades(newGrades)
  }

  const addTemplates = () => {
    let courseList = []
    let letterList = []
    let unitList = []
    let closeList = []
    if (grades.length > 0) {
      for (let grade of grades) {
        courseList.push(grade[0])
        unitList.push(grade[2])
        letterList.push(grade[3])

        closeList.push('')
      }
    }
    setCourseList(courseList)
    setUnitList(unitList)
    setCloseList(closeList)
    setLetterList(letterList)
  }

  const computeAdditional = () => {
    const desiredQPI = 3.51
    const unitsLeft = 9
    console.log(gradesAndUnits)
    const totalgraderesult = (gradesAndUnits[1] + unitsLeft) * desiredQPI
    console.log(gradesAndUnits[0])
    console.log(totalgraderesult)
    console.log((totalgraderesult - gradesAndUnits[0]) / unitsLeft)
  }
  return (
    <div className='App'>
      <div className='container'>
        <h1>QPI Calculator</h1>
        {/* <button onClick = {computeAdditional}>Click here</button> */}
        <div className='qpi-display'>
          <QPI score={qpi} />
          {/* <MinimumQPI /> */}
        </div>
        <Controls addGrades={addGrades} resetGrades={resetGrades} />
        <GradeList
          grades={grades}
          courses={courseList}
          letters={letterList}
          units={unitList}
          close={closeList}
          computeGrades={computeGrades}
          removeGrade={removeGrade}
          changeNames={changeNames}
        />
        <Form splitGrades={splitGrades} />
      </div>

      {/* <Hero/> */}
    </div>
  )
}

export default App
